import i18next from 'i18next'
import * as React from 'react'
import { InviewProps } from '../blocksState'
import { LinkGridBlockLayout } from '../linkGridBlockLayout'
import { ActualityPageData } from '../../sharepointPageApi/types/pageData'
import { getImageUrls } from '../../../../utils/sharepointImageUrls'
import { linkGridSrc, linkGridSrcSet } from '../../../../utils/imageSizes'

export type RelatedActualitiesBlockProps = {
  index: number
  inview?: InviewProps
  items: ActualityPageData[]
}

export function RelatedActualitiesBlockLayout(
  props: RelatedActualitiesBlockProps
) {
  return (
    props.items.length > 0 ? // ONLY SHOW BLOCK IF THERE ARE RESULTS
      <LinkGridBlockLayout
        index={props.index}
        title={i18next.t('actualities:related')}
        inview={props.inview}
        withImages={true}
        noItemsMessage={i18next.t('actualities:noRelatedActualities')}
        imageOptions={{
          src: linkGridSrc,
          srcset: linkGridSrcSet,
          sizes: 'auto',
          lazyload: true,
          width: '320',
          height: '160'
        }}
        primaryAction={{
          url: '/actualiteiten',
          title: i18next.t('actualities:viewAll')
        }}
        items={props.items.map(item => ({
          title: item.HeaderTitle,
          intro: !!item.PublicationDate ? new Date(item.PublicationDate).toLocaleString('nl-NL', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
          }) : "",
          link: {
            url: item.AbsolutePath,
            title: item.HeaderTitle
          },
          image: item.HeaderImage
            ? {
                alt: item.HeaderTitle,
                urls: getImageUrls(item.HeaderImage),
                keepOriginalSize: false
              }
            : undefined
        }))}
        isRelatedActualities={true}
      />
    : <></>
  )
}
